import { render } from "./EntitiesListShowModal.vue?vue&type=template&id=2c845d6e"
import script from "./EntitiesListShowModal.vue?vue&type=script&lang=js"
export * from "./EntitiesListShowModal.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__